import { api } from "../Configurations/axios";

const PutValueEbtida = async (id: string, value: number, userEmail: string, type: string, companyId: string) => {
    try {
        const result = await api.put('/Ebtida/PutValuesOnEbtida', { id: id, userEmail: userEmail, type: type, value: value, companyId: companyId });
        const response = await result.data;
        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}

export {
    PutValueEbtida
}